export default "__VITE_ASSET__0k7VJwM9__"